export const SkiDataTableColumns = [
  'id',
  'action',
  'customerPhone',
  'carParkCode',
  'registrationMark',
  'status',
  'retry'
]
